import React from 'react';
import Tag from './tag';

const TagSection = ({ maxTags, node }) => {
  let tagSelection;
  if(maxTags) {
    tagSelection = node.frontmatter.tags.slice(0,maxTags);
  } else {
    tagSelection = node.frontmatter.tags;
  }
  return (
    <section className="article-tags">
      <span className="tags-list-start">Tags:</span> {tagSelection.map(tag => <Tag url={tag.replace(/\s/g,'-')}>{tag}</Tag>)}
    </section>
  );
}

export default TagSection;
